<template>
  <div class="form-group">
    <label>{{ $_("visualEditor-emailEditor-common-margin") }}</label>
    <VeSpacingPicker
      v-model="marginProxy"
      :y-label="$_('visualEditor-emailEditor-common-axisY')"
      :x-label="$_('visualEditor-emailEditor-common-axisX')"
      :centerLabel="$_('visualEditor-emailEditor-common-margin')"
      :min="0"
      :max="200"
      :step="1"
    />
  </div>
</template>

<script>
import VeSpacingPicker from "../components/VeSpacingPicker.vue";

export default {
  name: "VeBlockMarginsSettings",
  components: { VeSpacingPicker },
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    marginProxy: {
      get() {
        const mt = Number(this.block?.settings?.marginTop ?? 0);
        const mr = Number(this.block?.settings?.marginRight ?? 0);
        const mb = Number(this.block?.settings?.marginBottom ?? 0);
        const ml = Number(this.block?.settings?.marginLeft ?? 0);
        const safe = (n) => (Number.isFinite(n) && n >= 0 ? Math.round(n) : 0);
        return { top: safe(mt), right: safe(mr), bottom: safe(mb), left: safe(ml) };
      },
      set(next) {
        const v = next || {};
        const safe = (n) => (Number.isFinite(n) ? Math.max(0, Math.round(n)) : 0);
        if (!this.block.settings) this.$set(this.block, "settings", {});
        this.$set(this.block.settings, "marginTop", safe(Number(v.top)));
        this.$set(this.block.settings, "marginRight", safe(Number(v.right)));
        this.$set(this.block.settings, "marginBottom", safe(Number(v.bottom)));
        this.$set(this.block.settings, "marginLeft", safe(Number(v.left)));
      },
    },
  },
};
</script>
